export default [
    {
        path: 'entrada',
        component: () => import(/* weimunizacaockChunkName: 'imunizacao-entrada' */ '@/views/imunizacao/entrada/Index'),
        redirect: 'entrada/index',
        children: [
            {
                name: 'imunizacao-entrada-index',
                path: 'index',
                component: () => import(/* weimunizacaockChunkName: 'imunizacao-entrada' */ '@/views/imunizacao/entrada/List.vue'),
            },
            {
                name: 'imunizacao-entrada-create',
                path: 'create',
                component: () => import(/* weimunizacaockChunkName: 'imunizacao-entrada' */ '@/views/imunizacao/entrada/Form.vue'),
            },
        ],
    },
]